<template>
  <v-content>
    <v-layout row wrap v-if="1 == 2">
      <v-spacer></v-spacer>
      <v-flex
        style="position:fixed; margin-top: 0; top: 0; right:22px"
        xs1
        v-for="language in getLanguages"
        :key="language.language"
      >
        <v-btn icon @click="changeLanguage(language.language)">
          <v-avatar style="border: solid white thin" size="32px">
            <select
              v-model="selectedLanguage"
              name="frm-lang"
              id="frm-lang"
              @change="changeLanguage"
              style="float: right"
            >
              <option value="pt-BR">PT-BR</option>
              <option value="en-US">EN-US</option>
            </select>
          </v-avatar>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm6 offset-sm3 md4 offset-md4>
          <div
            id="pergunta"
            class="fullHeight"
            v-if="state == 0"
            style="text-align: center"
          >
            <img
              :src="'data:image/png;base64, ' + logo"
              alt="Vagalume"
              width="88px"
              v-if="isLoaded"
            />
            <v-form v-model="formCadastroOk" v-if="isLoaded">
              <v-container>
                <v-layout column>
                  <v-flex v-for="field in activeFields" :key="field.id">
                    <v-text-field
                      v-if="field.type == 'string'"
                      :ref="'ref-' + field.name"
                      type="text"
                      :label="field.label"
                      v-model="userAuth[field.name]"
                      outline
                      
                      :rules="
                        (field.required ||
                          ((field.name == 'email' ||
                            field.name == 'cpf' ||
                            field.name == 'phone' ||
                            field.name == 'name') &&
                            userAuth.hasOwnProperty(field.name) &&
                            userAuth[field.name].length > 0)) &&
                        !(
                          isEditingObject.hasOwnProperty(field.name) &&
                          isEditingObject[field.name].editing
                        )
                          ? field.name == 'cpf'
                            ? cpfRules
                            : field.name == 'email'
                            ? ruleEmail
                            : field.name == 'phone'
                            ? rulePhone
                            : field.name == 'name'
                            ? ruleName
                            : [v => !!v || 'Campo obrigatório']
                          : [true]
                      "
                      :required="
                        (field.required ||
                          ((field.name == 'email' ||
                            field.name == 'cpf' ||
                            field.name == 'phone' ||
                            field.name == 'name') &&
                            userAuth.hasOwnProperty(field.name) &&
                            userAuth[field.name].length > 0)) &&
                          !(
                            isEditingObject.hasOwnProperty(field.name) &&
                            isEditingObject[field.name].editing
                          )
                      "
                      :mask="
                        !isEditingObject.hasOwnProperty(field.name) ||
                        !isEditingObject[field.name].editing
                          ? field.name == 'cpf'
                            ? '###.###.###-##'
                            : field.name == 'phone'
                            ? '(##) #####-####'
                            : ''
                          : false
                      "
                      class="field"
                      @focus="editField(field, true)"
                    ></v-text-field>

                    <v-text-field
                      v-if="field.type == 'password'"
                      :ref="'ref-' + field.name"
                      type="password"
                      :label="field.label"
                      v-model="userAuth[field.name]"
                      outline
                      
                      :required="field.required"
                      class="field"
                      @focus="editField(field, true)"
                    ></v-text-field>

                    <v-text-field
                      v-if="field.type == 'number'"
                      :ref="'ref-' + field.name"
                      type="number"
                      :label="field.label"
                      v-model.number="userAuth[field.name]"
                      outline
                      
                      :required="field.required"
                      class="field"
                    ></v-text-field>

                    <span v-if="field.type == 'date'">{{ field.label }}</span>
                    <v-layout row v-if="field.type == 'date' && field.name">
                      <v-flex xs4>
                        <v-select
                          outline
                          
                          v-model="userAuth[field.name + '_dd']"
                          :id="'id_' + field.name + '_dd'"
                          :required="field.required"
                          class="field"
                          label="Dia"
                          :items="dias"
                          @change="changeDate(field.name)"
                        ></v-select>
                      </v-flex>
                      <v-flex xs4>
                        <v-select
                          outline
                          
                          v-model="userAuth[field.name + '_mm']"
                          :id="'id_' + field.name + '_mm'"
                          :required="field.required"
                          class="field"
                          :items="meses"
                          label="Mês"
                          @change="changeDate(field.name)"
                        ></v-select>
                      </v-flex>
                      <v-flex xs4>
                        <v-select
                          outline
                          
                          v-model="userAuth[field.name + '_yyyy']"
                          :id="'id_' + field.name + '_yyyy'"
                          :required="field.required"
                          class="field"
                          :items="anos"
                          label="Ano"
                          @change="changeDate(field.name)"
                        ></v-select>
                      </v-flex>
                    </v-layout>

                    <input
                      v-if="field.type == 'date'"
                      type="hidden"
                      :value="userAuth[field.name]"
                      :required="field.required"
                    />

                    <v-switch
                      v-if="field.type == 'boolean'"
                      v-model="userAuth[field.name]"
                      :label="field.label"
                      outline
                      
                      :color="primaryColor"
                    ></v-switch>

                    <v-select
                      outline
                      
                      v-if="field.type == 'list'"
                      v-model="userAuth[field.name]"
                      :id="'id_' + field.name"
                      :required="field.required"
                      class="field"
                      :items="field.options"
                      :label="field.label"
                      item-text="label"
                      item-value="value"
                      @change="editField(field, false)"
                    ></v-select>
                  </v-flex>
                  <v-flex v-if="isLoaded">
                    <v-checkbox
                      color="orange"
                      v-model="userAuth['termoAceito']"
                    >
                      <template v-slot:label>
                        <span>{{ $t("Aceito os") }}&nbsp;</span>
                        <span @click="dialog = true" class="meulink">{{
                          $t("Termos de Serviço")
                        }}</span>
                      </template>
                    </v-checkbox>
                  </v-flex>
                  <!-- <v-flex v-for="termo in client_data.lgpd" :key="termo.id">
                    <v-checkbox
                      color="orange"
                      v-model="lgpd_accepted[termo.id]"
                    >
                      <template v-slot:label>
                        <span>{{ termo.text }}</span>
                      </template>
                    </v-checkbox>
                  </v-flex> -->
                  <v-flex v-if="!isEditing"> </v-flex>
                  <v-flex v-if="isEditing && !newUser">
                    <v-btn
                      small
                      :style="
                        'background-color:' +
                          primaryColor +
                          '; color:' +
                          secondaryColor
                      "
                      @click.native="goBoasVindas()"
                      >{{ $t("Voltar") }}</v-btn
                    >
                  </v-flex>
                  <v-flex v-if="isEditing">
                    <v-btn
                      :style="
                        'background-color:' +
                          primaryColor +
                          '; color:' +
                          secondaryColor
                      "
                      @click.native="updateUserAuth()"
                      :disabled="
                        (!(formUpdateOk() && isDirty()) ||
                          isSaving ||
                          !userAuth.termoAceito ||
                          !filledRequiredFields) &&
                          !newUser
                      "
                      :loading="isSaving"
                      >{{ $t("Atualizar e Entrar") }}</v-btn
                    >
                  </v-flex>
                  <v-flex v-else>
                    <v-btn
                      :style="
                        'background-color:' +
                          primaryColor +
                          '; color:' +
                          secondaryColor
                      "
                      @click.native="insertConsultor"
                      :disabled="
                        !formCadastroOk ||
                          isSaving ||
                          !userAuth.termoAceito ||
                          !filledRequiredFields
                      "
                      :loading="isSaving"
                    >
                      {{ $t("Salvar e Entrar") }}
                    </v-btn>
                    <!-- <v-btn
                      :style="'background-color:' + primaryColor + '; color:' + secondaryColor"
                      @click.native="acceptAllTerms"
                      :disabled="!formCadastroOk || isSaving || !filledRequiredFields"
                      :loading="isSaving"
                    >
                      {{$t('Aceitar tudo e Entrar')}}
                    </v-btn> -->
                  </v-flex>
                  <v-flex>
                    <v-btn
                      :style="'background-color: orange; color: white;'"
                      @click="autoChangeLanguage()"
                    >
                      &nbsp;{{ $t("Mudar Idioma") }}
                    </v-btn>
                  </v-flex>

                  <v-flex></v-flex>
                </v-layout>
              </v-container>

              <v-dialog v-model="dialog" width="500">
                <v-card>
                  <v-card-title class="headline grey lighten-2" primary-title>
                    <v-layout align-space-between justify-space-between row>
                      <span>Termos de Serviço</span>
                      <v-btn small icon @click="dialog = false">
                        <v-icon>clear</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-card-title>

                  <v-card-text
                    v-if="
                      selectedLanguage == 'pt-BR' &&
                        termsOfUse &&
                        termsOfUse.length > 0
                    "
                    v-html="termsOfUse"
                  ></v-card-text>

                  <v-card-text
                    v-else-if="
                      selectedLanguage == 'en-US' &&
                        termsOfUseEnglish &&
                        termsOfUseEnglish.length > 0
                    "
                    v-html="termsOfUseEnglish"
                  ></v-card-text>

                  <v-card-text v-else>
                    <div>
                      <ol>
                        <li>
                          <h2>DEFINIÇÕES</h2>
                          <ol type="a">
                            <li>
                              Para o presente termo, todas as palavras ou
                              expressões constantes na lista abaixo deverão ser
                              entendidas conforme o respectivo significado:
                              <ol type="i">
                                <li>CLIENTE é a pessoa que faz uso da WIFI;</li>
                                <li>
                                  ESTABELECIMENTO aqui identificado como o
                                  provedor da WIFI;
                                </li>
                                <li>
                                  INTERNET é uma rede mundial que interliga
                                  milhões de computadores e dispositivos em todo
                                  o mundo, de vários tipos e tamanhos, marcas e
                                  modelos;
                                </li>
                                <li>
                                  WIFI é o acesso à rede oferecida por este
                                  ESTABELECIMENTO, utilizando tecnologia de
                                  redes sem fio, baseadas na especificação IEEE
                                  802.11, que define a infraestrutura física de
                                  acesso à uma rede sem a necessidade de
                                  utilização de cabos, responsável pela
                                  limitação de velocidade, faixa de frequência,
                                  método de acesso e conectividade à INTERNET.
                                </li>
                              </ol>
                            </li>
                            <li>
                              Ao utilizar esta rede WIFI, o CLIENTE
                              expressamente aceita, sem reservas ou ressalvas,
                              todas as condições abaixo descritas para
                              utilização deste serviço, observando que serviço
                              poderá ser interrompido a qualquer momento sem
                              prévio aviso.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h2>NORMAS DE USO</h2>
                          <ol type="a">
                            <li>
                              O CLIENTE deverá dispor e manter o equipamento
                              necessário (ex: computador, notebook, celulares ou
                              tablets não se limitando apenas a estes),
                              compatível com a tecnologia IEEE 802.11 para ter
                              acesso à INTERNET, bem como deverá promover as
                              medidas de segurança necessárias à proteção de
                              seus equipamentos e dados contra a atuação
                              indevida e invasões não autorizadas de outros
                              usuários da INTERNET e/ou WIFI.
                            </li>
                            <li>
                              O CLIENTE não poderá utilizar a WIFI para os
                              seguintes propósitos:i.Propagar ou manter SITE na
                              INTERNET ou WIFI;ii.Infringir qualquer lei ou
                              regulamento local, estadual, nacional ou
                              internacional aplicável;iii. Consumir inutilmente
                              os recursos computacionais de forma
                              intencional;iv. Interceptar ou tentar interceptar
                              a transmissão de dados através de monitoração da
                              WIFI ou INTERNET;
                            </li>
                            <li>
                              O CLIENTE será o único responsável pelo acesso ao
                              conteúdo da WIFI e da INTERNET, não se limitando
                              apenas a estas, o qual assume todos os ônus e
                              responsabilidades decorrentes de seus atos.
                            </li>
                            <li>
                              O CLIENTE declara e garante, para todos os fins de
                              direito possuir capacidade jurídica para celebrar
                              e utilizar o serviço objeto deste termo e que está
                              ciente e de pleno acordo com todas as condições
                              apresentadas.
                            </li>
                            <li>
                              O CLIENTE é vedada pelo ESTABELECIMENTO a
                              comercialização de serviço ou produtos para
                              pessoas físicas ou jurídicas, bem como a formação
                              de rede local sem fio em tal ESTABELECIMENTO
                              utilizando a WIFI.
                            </li>
                            <li>
                              A violação destas obrigações está sujeita às penas
                              previstas em lei.
                            </li>
                            <li>
                              O ESTABELECIMENTO deverá envidar os melhores
                              esforços para assegurar e desenvolver a qualidade
                              do serviço objeto deste termo, comprometendo-se,
                              ainda, a respeitar a privacidade do CLIENTE,
                              garantindo que não divulgará informações relativas
                              à sua utilização e informações cadastrais
                              fornecidas, a menos que seja obrigada a fazê-lo
                              mediante ordem judicial ou por lei, ressalvadas as
                              hipóteses previstas neste termo.
                            </li>
                            <li>
                              O ESTABELECIMENTO não tem obrigação de controlar,
                              e não controla o conteúdo e natureza dos conteúdos
                              transmitidos, difundidos ou postos à disposição
                              pelos CLIENTES, através da WIFI.
                            </li>
                            <li>
                              O ESTABELECIMENTO não se responsabiliza, por
                              possível indisponibilidade temporária ou não do
                              acesso à INTERNET ou outros recursos através da
                              WIFI, mesmo que estes possam causar perdas, danos,
                              despesas ou lucros cessantes direta ou
                              indiretamente ao CLIENTE ou terceiros.
                            </li>
                            <li>
                              Antes de usar este serviço de rede WIFI, você deve
                              registrar alguns de seus dados, através de uma
                              checagem on-line em nosso portal. Depois do
                              registro, seu dispositivo será reconhecido
                              automaticamente, e você poderá usar o serviço. Se
                              você tiver vários dispositivos, você deve
                              registrar cada dispositivo de forma individual.
                            </li>
                            <li>
                              Você não pode utilizar este serviço com
                              dispositivos que não seja de sua propriedade,
                              exceto mediante permissão expressa do
                              proprietário.
                            </li>
                            <li>
                              Você concorda que cada vez que você se conectar a
                              este serviço de rede WIFI gratuito, e em outras
                              vezes conforme considerarmos adequado, podemos
                              direcionar seu dispositivo para um site ou outro
                              local para a exibição de material promocional ou
                              de publicidade de qualquer forma, e que você pode
                              ser impedido de usar a Internet pela duração que
                              consideramos apropriada para a exibição desse
                              material.
                            </li>
                            <li>
                              Você concorda que poderemos limitar ou restringir
                              seu acesso ao Serviço nosso exclusivo critério não
                              importando o tempo, inclusive controlar em que
                              velocidade o seu dispositivo poderá enviar e
                              receber dados sobre o Serviço, bem como restringir
                              o tempo em que um dispositivo pode estar conectado
                              ao Serviço, e além disso filtrar ou bloquear o
                              acesso a determinados sites ou outro material
                              acessível pela Internet através do Serviço.
                            </li>
                            <li>
                              É de responsabilidade exclusiva do usuário a
                              correta utilização dos recursos oferecidos por
                              este Serviço, respondendo por sua má utilização,
                              tanto judicial como extrajudicialmente.
                            </li>
                            <li>
                              O oferecimento dos referidos recursos é gratuito e
                              está sujeito à disponibilidade técnica da
                              organização, podendo haver interrupções dos mesmos
                              sem prévio aviso.
                            </li>
                            <li>
                              Em nenhuma hipótese o ESTABELECIMENTO será
                              responsável, direta ou indiretamente, por:
                              <ol type="i">
                                <li>
                                  falhas, impossibilidades técnicas ou
                                  indisponibilidades do sistema.
                                </li>
                                <li>
                                  instalação no equipamento do usuário ou de
                                  terceiros, de vírus, trojans, malware, worm,
                                  bot, backdoor, spyware, rootkit, ou de
                                  quaisquer outros dispositivos que venham a ser
                                  criados, em decorrência da navegação na
                                  Internet pelo usuário.
                                </li>
                                <li>
                                  despesas, danos ou perdas que sejam efetiva ou
                                  alegadamente causados por quaisquer conteúdos,
                                  produtos ou serviços acessados através do
                                  WIFI, não garantindo a perfeição, qualidade,
                                  veracidade, adequação, utilidade ou segurança
                                  do conteúdo ou de qualquer serviço oferecido,
                                  inclusive, mas não se limitando a, serviços
                                  envolvendo investimentos, seguros, aplicações,
                                  transferências de valores, e demais operações
                                  financeiras, ou pela utilização ou confiança
                                  depositada pelo CLIENTE em tais conteúdos,
                                  produtos ou serviços.
                                </li>
                              </ol>
                            </li>
                            <li>
                              O usuário declara estar ciente de que todos e
                              quaisquer conteúdos enviados e/ou transmitidos ao
                              site por qualquer usuário não representam, de
                              nenhuma forma, a opinião ou a visão do Shopping.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h2>PRIVACIDADE</h2>
                          <ol type="a">
                            <li>
                              DADOS COLETADOS SOBRE USUÁRIO: "Dados pessoais"
                              são informações sobre o usuário, com as quais
                              podemos ou não o identificar. Os tipos de dados
                              pessoais que podemos coletar incluem:
                              <ol type="i">
                                <li>Nome, endereço, e-mail, telefone e CPF;</li>
                                <li>
                                  Endereço MAC do dispositivo (identificador
                                  único relacionado a todo dispositivo capaz de
                                  se conectar a rede com ou sem fio);
                                </li>
                                <li>
                                  Informações sobre as preferências, opinião ou
                                  informação dos usuários, a partir de nossos
                                  questionários;
                                </li>
                                <li>
                                  Informações demográficas, como faixa etária,
                                  sexo, formação, dentre outros.
                                </li>
                              </ol>
                            </li>
                            <li>
                              FORMAS DE COLETAR OS DADOS DOS USUÁRIOS: O
                              ESTABELECIMENTO poderá coletar as informações de
                              seus usuários, das seguintes formas:
                              <ol type="i">
                                <li>
                                  Quando os usuários usarem a rede WIFI do
                                  ESTABELECIMENTO;
                                </li>
                                <li>
                                  Quando os usuários se cadastrarem para
                                  utilizar a rede WIFI do ESTABELECIMENTO
                                </li>
                              </ol>
                            </li>
                            <li>
                              USO DOS DADOS COLETADOS
                              <ol type="i">
                                <li>
                                  Quando você cadastrar para utilizar o Serviço,
                                  você deverá fornecer determinadas informações,
                                  algumas das quais podem ser informações
                                  pessoais para efeitos da lei brasileira. Se
                                  você não fornece essas informações, nós
                                  poderemos nos recusar a fornecer o acesso ao
                                  Serviço.
                                </li>
                                <li>
                                  Você concorda que poderemos coletar os seus
                                  dados da sua conexão conforme necessário para
                                  adequação do Serviço.
                                </li>
                                <li>
                                  Nós podemos usar quaisquer informações que
                                  coletamos a qualquer momento, inclusive depois
                                  de você parar de usar o Serviço, por tempo
                                  indeterminado.
                                </li>
                                <li>
                                  Ao utilizar esse Serviço, você confirma que
                                  todas as informações que forneceu é
                                  verdadeira.
                                </li>
                              </ol>
                            </li>
                            <li>
                              PRA QUE UTILIZAMOS OS DADOS COLETADOS
                              <ol type="i">
                                <li>
                                  Melhorar as experiências de navegação dos
                                  usuários
                                </li>
                                <li>
                                  Permitir o fornecimento de serviços mais
                                  personalizados e adequados às necessidades dos
                                  usuários, tais como páginas de perfil,
                                  atualizações, conteúdos e anúncios relevantes;
                                </li>
                                <li>
                                  Permitir a comunicação entre os usuários e o
                                  ESTABELECIMENTO, inclusive mediante o envio e
                                  recebimento de mensagens, tais como e-mails,
                                  mensagens de texto (SMS) e push messages
                                  (mensagens personalizadas enviadas
                                  automaticamente para os aparelhos dos
                                  clientes), mas não restrito a apenas estes, se
                                  permitidos
                                </li>
                                <li>
                                  Identificar os perfis, hábitos e necessidades
                                  para eventuais ofertas de serviços e
                                  estratégias do ESTABELECIMENTO.
                                </li>
                                <li>
                                  O ESTABELECIMENTO preserva a privacidade dos
                                  usuários e não compartilham seus dados e
                                  informações com terceiros, salvo nos itens
                                  listados no ponto 3.e., mediante consentimento
                                  do próprio usuário, ou em caso de ordem
                                  judicial, obrigação prevista na legislação
                                  vigente.
                                </li>
                                <li>
                                  O usuário está ciente e autoriza que os seus
                                  registros de navegação sejam fornecidos pelo
                                  ESTABELECIMENTO a seus respectivos parceiros
                                  e/ou contratados para prestar qualquer serviço
                                  relativo aos serviços oferecidos, sem
                                  indicação individualizada do usuário que
                                  permita sua identificação e para as
                                  finalidades aqui previstas. Os funcionários ou
                                  terceiros que se utilizarem indevidamente
                                  dessas informações, ferindo essa Política de
                                  Privacidade, estarão sujeitos às penalidades
                                  previstas na legislação vigente.
                                </li>
                                <li>
                                  Ainda que nossos usuários apaguem/excluam suas
                                  contas do ESTABELECIMENTO, o Shopping ainda
                                  poderá manter os dados não-pessoais dos
                                  usuários, como uso da rede e localização.
                                </li>
                                <li>
                                  Envie material publicitário relacionado aos
                                  nossos produtos e serviços, exceto quando você
                                  expressar seu desejo de não receber tal
                                  material, sendo feito por qualquer meio
                                  razoável. Usando as informações fornecidas,
                                  podemos criar perfis de vendas com o objetivo
                                  de oferecer produtos e serviços que
                                  correspondam aos seus interesses. A
                                  autorização para processar os seus Dados para
                                  este fim é opcional e, se você optar por isso,
                                  a única consequência será que você não
                                  receberá informações sobre nossos produtos e
                                  serviços.
                                </li>
                                <li>
                                  Atender às obrigações de retenção de dados
                                  para comunicações eletrônicas. De acordo com a
                                  legislação vigente, fornecer dados para este
                                  propósito é obrigatório.
                                </li>
                                <li>
                                  Melhorar o nosso serviço de atendimento ao
                                  cliente, bem como manter contato com nossos
                                  clientes.
                                </li>
                              </ol>
                            </li>
                            <li>
                              COMPARTILHAMENTO DOS DADOS COLETADOS.
                              <ol type="i">
                                <li>
                                  Seus dados pessoais poderão ser compartilhados
                                  com fornecedores que atuam como processadores
                                  de dados do ESTABELECIMENTO e somente de
                                  acordo com suas instruções. O ESTABELECIMENTO
                                  usa diversos fornecedores que se enquadram nas
                                  seguintes categorias: fornecedores de serviços
                                  de TI e rede, fornecedores de software
                                  (incluindo fornecedores de serviços
                                  gerenciados e de software como serviço),
                                  analíticos e de melhoria de serviços,
                                  terceirizados e fornecedores de serviços de
                                  suporte de negócios. Nos casos em que o
                                  ESTABELECIMENTO fornece dados pessoais a esses
                                  fornecedores, exige que medidas de segurança
                                  adequadas estejam em vigor.
                                </li>
                                <li>
                                  O ESTABELECIEMENTO poderá compartilhar
                                  informações que não sejam pessoalmente
                                  identificáveis agregadas, publicamente e com
                                  seus parceiros, tais como sites de editores,
                                  anunciantes ou sites relacionados, com a
                                  finalidade, por exemplo, de mostrar tendências
                                  sobre o uso geral do ESTABELECIMENTO.
                                </li>
                              </ol>
                            </li>
                            <li>
                              DIREITOS RELACIONADOS AOS SEUS DADOSi. Você pode
                              exercer seus direitos de acessar, alterar, excluir
                              e contestar os dados que você forneceu. Se desejar
                              notificar-nos a este respeito, envie-nos o seu
                              pedido por escrito para: suporte@elcoma.com.br.
                              Não se esqueça de indicar claramente o direito que
                              deseja exercer.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <h2>GERAL</h2>
                          <ol type="a">
                            <li>
                              Estes Termos, incluindo a Política de Privacidade,
                              são regidos pelas leis brasileiras em vigor. O
                              foro de Recife-PE, Brasil é eleito para resolver
                              quaisquer questões decorrentes destes Termos.
                            </li>
                            <li>
                              Se qualquer disposição deste Termo for considerada
                              nula ou inexequível, essa disposição será
                              interpretada, na medida do possível, conforme
                              necessário para torná-la válida e exequível e,
                              caso isso não seja possível, será considera
                              excluída, permanecendo as demais disposições
                              inalteradas.
                            </li>
                          </ol>
                        </li>
                      </ol>
                    </div>
                  </v-card-text>

                  <v-divider></v-divider>

                  <!-- <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      :disabled="userAcceptedTerms"
                      color="primary"
                      flat
                      @click="optin()"
                      >Aceitar</v-btn
                    >
                  </v-card-actions> -->
                </v-card>
              </v-dialog>
            </v-form>
          </div>

          <div
            v-cloak
            id="divForm"
            v-else-if="
              state == 1 &&
                randomQuestion &&
                randomQuestion.birt &&
                randomQuestion &&
                !randomQuestion.multiple
            "
            style="text-align: center"
            class="fullHeight"
          >
            <img
              :src="'data:image/png;base64, ' + logo"
              alt="Vagalume"
              width="88px"
            />

            <v-form v-model="formOk">
              <v-container>
                <v-layout column>
                  <v-flex>
                    <h1 class="titulo" :style="'color:' + textColor">
                      {{ randomQuestion.text }}
                    </h1>
                  </v-flex>
                  <v-flex
                    v-for="answer in randomQuestion.answers"
                    :key="answer.id"
                  >
                    <v-btn
                      class="answer"
                      large
                      :style="
                        'background-color:' +
                          primaryColor +
                          '; color:' +
                          secondaryColor +
                          ';width: 80%'
                      "
                      @click.native="choiceAnswer(answer)"
                      :disabled="isAnswering"
                      :loading="isAnswering"
                      >{{ answer.text }}</v-btn
                    >
                  </v-flex>
                  <v-btn
                    class="answer"
                    large
                    @click.native="skipAnswer()"
                    :style="
                      'background-color:' +
                        secondaryColor +
                        '; color:' +
                        primaryColor +
                        ';width: 80%'
                    "
                    :disabled="isAnswering"
                    :loading="isAnswering"
                    >Skip</v-btn
                  >
                </v-layout>
              </v-container>
            </v-form>
          </div>
          <div
            v-cloak
            id="divForm"
            v-else-if="state == 1 && randomQuestion"
            style="text-align: center"
            class="fullHeight"
          >
            <img
              :src="'data:image/png;base64, ' + logo"
              alt="Vagalume"
              width="88px"
            />

            <v-form v-model="formOk">
              <v-container>
                <v-layout column>
                  <v-flex>
                    <h1 class="titulo" :style="'color:' + textColor">
                      {{ randomQuestion.text }}
                    </h1>
                  </v-flex>
                  <v-flex
                    v-for="answer in randomQuestion.answers"
                    :key="answer.id"
                  >
                    <v-btn
                      class="answer"
                      large
                      :style="
                        'background-color:' +
                          primaryColor +
                          '; color:' +
                          secondaryColor +
                          ';width: 80%'
                      "
                      @click.native="choiceAnswer(answer)"
                      :disabled="isAnswering"
                      :loading="isAnswering"
                      >{{ answer.text }}</v-btn
                    >
                  </v-flex>
                  <v-btn
                    v-if="1 == 2"
                    class="answer"
                    large
                    @click.native="skipAnswer()"
                    :style="
                      'background-color:' +
                        secondaryColor +
                        '; color:' +
                        primaryColor +
                        ';width: 80%'
                    "
                    :disabled="isAnswering"
                    :loading="isAnswering"
                    >Skip</v-btn
                  >
                </v-layout>
              </v-container>
            </v-form>
          </div>

          <div
            v-cloak
            id="divForm"
            v-else-if="state == 2"
            style="text-align: center"
            class="fullHeight"
          >
            <video
              v-if="midiaType == 'video' && midiaLink"
              class="full"
              playsinline
              preload
              autoplay
              muted="true"
              ref="videoRef"
              @click="playVideo()"
              v-on:ended="endVideo"
              v-on:progress="playVideo"
            >
              <source
                :src="midiaLink"
                type="video/mp4"
                @error="imageLoadError(1)"
              />
            </video>

            <v-progress-circular
              v-if="midiaType == 'image' && midiaLink"
              class="overlay"
              :rotate="360"
              :size="44"
              :width="4"
              :value="tempoPassado"
              color="#999"
            ></v-progress-circular>
            <img
              v-if="midiaType == 'image' && midiaLink"
              :src="midiaLink"
              class="fullImg"
              alt
              v-on:load="loadedImage()"
              @error="imageLoadError(1)"
            />

            <v-chip
              class="overlay center elevation-1"
              style="max-width: 80vw; min-width: 120px; height: 36px; margin-top: 70vh; opacity: 0.8"
              >Aguarde para ser conectado.</v-chip
            >
          </div>

          <div
            style="text-align: center"
            v-else-if="state == 3"
            class="fullHeight"
          >
            <img
              :src="'data:image/png;base64, ' + logo"
              alt="Vagalume"
              width="88px"
            />

            <v-container>
              <v-layout column>
                <v-flex xs12>Aguarde</v-flex>

                <v-flex xs12>
                  <v-progress-circular
                    :width="3"
                    color="red"
                    indeterminate
                  ></v-progress-circular>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div
            id="boas_vindas"
            v-else-if="state == 10"
            style="text-align: center"
            class="fullHeight"
          >
            <img
              :src="'data:image/png;base64, ' + logo"
              alt="Vagalume"
              width="160px"
              v-if="isLoaded"
            />

            <v-layout
              column
              align-content-space-between
              justify-space-between
              fill-height
            >
              <v-flex
                :style="
                  'max-height:88px; padding-top: 22px; font-size: large; font-weight: bold; color:' +
                    textColor
                "
                >{{ welcome }}</v-flex
              >

              <v-flex>
                <v-layout column>
                  <v-btn
                    large
                    :style="
                      'background-color:' +
                        primaryColor +
                        '; color:' +
                        secondaryColor
                    "
                    @click="continueFlow()"
                    >{{ $t("Continuar") }}</v-btn
                  >

                  <v-btn
                    small
                    :style="
                      'background-color:' +
                        primaryColor +
                        '; color:' +
                        secondaryColor
                    "
                    @click="editUserData()"
                    >{{ $t("Editar dados") }}</v-btn
                  >
                </v-layout>
              </v-flex>

              <v-flex>
                <v-layout column>
                  <v-btn
                    small
                    :style="
                      'background-color:' +
                        secondaryColor +
                        '; color:' +
                        primaryColor
                    "
                    @click="replaceUser()"
                    >{{ $t("Desvincular") }}</v-btn
                  >

                  <div
                    style="background-color: white; opacity: 0.8;border-radius:3px;padding: 14px; "
                    v-if="isLoaded"
                  >
                    <span
                      @click="optout()"
                      class="meulink"
                      style="font-size: x-small"
                      >{{ $t("Remover meus dados") }}</span
                    >
                  </div>
                  <v-flex>&nbsp;</v-flex>
                  <v-flex>
                    <div>
                      <v-btn
                        :style="'background-color: orange; color: white;'"
                        @click="autoChangeLanguage()"
                      >
                        &nbsp;{{ $t("Mudar Idioma") }}
                      </v-btn>
                    </div>
                    <div>
                      <img
                        src="https://captive.elcoma.com.br/dev/static/img/logo_elcoma.png"
                        alt="Elcoma Networks"
                        height="24px"
                      />
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </div>

          <div
            v-else-if="state == 11"
            style="text-align: center"
            class="fullHeight"
          >
            <img
              :src="'data:image/png;base64, ' + logo"
              alt="Vagalume"
              width="160px"
              v-if="isLoaded"
            />

            <p
              large
              :style="
                'margin-top: 44px; font-size: large; color:' + secondaryColor
              "
            >
              {{ $t("Cadastre-se para navegar") }}
            </p>

            <v-layout column align-center justify-space-around fill-height>
              <v-flex>
                <v-text-field
                  v-if="false && isCpfRequired"
                  :rules="cpfRules"
                  label="CPF"
                  outline
                  mask="###.###.###-##"
                  
                  v-model="userAuth.cpf"
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-layout column align-center>
                  <v-flex>
                    <v-btn
                      :style="'background-color: orange; color: white;'"
                      @click="buscaCpf()"
                    >
                      <!--acima do > :disabled="
                        isCpfRequired && !applyRules(cpfRules, userAuth.cpf)
                      " -->
                      <v-icon>mail</v-icon>
                      &nbsp;&nbsp;{{ $t("Cadastrar") }}
                    </v-btn>
                  </v-flex>
                  <!-- <v-flex v-if="withFacebook">
                    <v-btn class="loginBtn--facebook" @click="fbLogin">
                      <img
                        src="https://captive.elcoma.com.br/static/f_logo.png"
                        height="40px"
                        style="display: block"
                      />
                      &nbsp; {{$t('Login com Facebook')}}
                    </v-btn>
                  </v-flex> -->
                </v-layout>
              </v-flex>
              <v-flex>
                <div>
                  <v-btn
                    :style="'background-color: orange; color: white;'"
                    @click="autoChangeLanguage()"
                  >
                    &nbsp;{{ $t("Mudar Idioma") }}
                  </v-btn>
                </div>
                <div>
                  <img
                    src="https://captive.elcoma.com.br/dev/static/img/logo_elcoma.png"
                    alt="Elcoma Networks"
                    height="24px"
                  />
                </div>
              </v-flex>
              <v-flex></v-flex>
              <v-flex></v-flex>
            </v-layout>
          </div>
        </v-flex>
        <!--
        <div>
          <v-layout>
                      <v-flex>
                      <v-btn
                      :style="'background-color: orange; color: white;'"
                      @click="buscaCpf()"
                      :disabled="isCpfRequired && !applyRules(cpfRules, userAuth.cpf)"
                    >
                      <v-icon>mail</v-icon>
                      {{$t('Cadastrar')}}
                    </v-btn>
                      </v-flex>
            </v-layout>
          </div>
          -->
      </v-layout>
    </v-container>
    <form
      ref="form1"
      id="id_form1"
      :action="formSubmit"
      method="POST"
      style="visibility: hidden"
    >
      <input type="text" name="auth_user" :value="userAuthField" />
      <input type="text" name="auth_pass" value="1234" />
      <input type="text" name="zone" :value="zone" />
      <input type="text" id="cid" name="clientMac" :value="mac" />
      <input ref="btn1" name="accept" type="submit" value="Login" />
    </form>
        <form ref="form2" id="id_form2" :action="formSubmit" method="POST" style="visibility: hidden">
      <input type="text" name="username" :value="mac.toLowerCase()" />
      <input type="text" name="password" value="senharadius" />
      <input type="text" name="dst" :value="redir_url" />
      <input type="text" name="zone" :value="zone" />
      <input type="text" id="cid" name="clientMac" :value="mac.toLowerCase()" />
      <input ref="btn2" name="accept" type="submit" value="Login" />
    </form>

    <v-dialog v-model="isSure" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          <v-layout align-space-between justify-space-between row>
            <span>{{ $t("Alerta") + "!" }}</span>
            <v-btn small icon @click="isSure = false">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-layout>
        </v-card-title>

        <v-card-text>
          <div>
            <p>
              {{
                $t("Os dados nesse portal serão removidos. Deseja continuar")
              }}?
            </p>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn small icon @click="isSure = false" color="primary" flat>{{
            $t("Não")
          }}</v-btn>

          <v-btn color="primary" flat @click="commitOut()">{{
            $t("Sim")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-content>
</template>
<script>
import Db from "@/db";
//const moment = require("moment-timezone");
const db = new Db();
import axios from "axios";
import i18n from "@/plugins/i18n";
//var Pepper = require("chilli-pepper");
var MobileDetect = require("mobile-detect");
var mde = new MobileDetect(window.navigator.userAgent);
//alert(mde.userAgent())
//alert(mde.os())
/* import QrCode from "qrcode-reader";
var qr = new QrCode(); */

export default {
  name: "Captive",
  data() {
    return {
      dialogMessage: false,
      message: { title: "", text: "", action: null },
      hour: "",
      dayOfWeek: 0,
      auth_success: true,
      cpa: "Swarm",
      uamIp: "",
      uamPort: 0,
      userurl: "https://www.google.com",
      isAPAuto: false,
      welcomeHeader_pt_BR: "",
      welcomeHeader_en_US: "",
      welcomeFooter_pt_BR: "",
      welcomeFooter_en_US: "",
      deleteType: "not-i-am",
      zone: "captive",
      termsOfUse: null,
      termsOfUseEnglish: null,
      withFacebook: true,
      client_id: null,
      selectedLanguage: "pt-BR",
      userDataFieldError: [],
      isSure: false,
      isEditingObject: {},
      userAuthClone: {},
      isReplacingUser: false,
      isEditing: false,
      _fbCode: undefined,
      _fbToken: undefined,
      tempoPassado: 0,
      ruleCpf: [],
      languages: [
        { flag: "us", language: "en-US" },
        { flag: "br", language: "pt-BR" }
      ],
      ruleData: [
        v => new RegExp(/\d{2}\/\d{2}\/\d{4}\d*/).test(v) || "Informe a data"
      ],
      ruleEmail: [
        v =>
          new RegExp(/^\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi).test(v) ||
          "E-mail invalido"
      ],
      rulePhone: [
        v =>
          new RegExp(/^[1-9]{2}(?:[2-8]|9[1-9])[0-9]{3}[0-9]{4}$/gm).test(v) ||
          "Phone invalido"
      ],
      ruleName: [
        v => (v && v.length > 6) || "Pelo menos 7 letras",
        v =>
          new RegExp(/[\wÀ-ü]+\s[\wÀ-ü]+(\s[\wÀ-ü]+)*/).test(v) ||
          "Pelo menos 2 palavras"
      ],
      teste: "",
      isLoaded: false,
      dialog: false,
      termoAceito: false,
      titulo: "Novo Captive",
      newUser: true,
      incompleteData: false,
      questions: [],
      videoPending: true,
      questionPending: true,
      auth_user_field: "name",
      fields: [],
      api_settings: [],
      randomQuestion: null,
      videos: [],
      randomVideo: null,
      client: "",
      dd: "",
      mm: "",
      aaaa: "",
      userAuth: {
        name: "",
        cpf: "",
        email: "",
        birth_date: "",
        gender: "",
        answers: [],
        mac: undefined,
        terms_accepted: [],
        termoAceito: false
      },
      connection: {
        user_id: "",
        controller_id: "",
        mac_address: "",
        ip: "",
        user_agent: undefined,
        system: undefined,
        ts_start_load_1: undefined,
        ts_end_load_1: undefined,
        ts_end_ident_2: undefined,
        ts_start_facebook_2: undefined,
        ts_end_facebook_2: undefined,
        ts_start_cpf_2: undefined,
        ts_end_cpf_2: undefined,
        ts_start_question_3: undefined,
        ts_end_question_3: undefined,
        ts_start_midia_4: undefined,
        ts_end_midia_4: undefined,
        ts_start_ext_5: undefined,
        ts_end_ext_5: undefined,
        ts_start_auth_6: undefined,
        ts_end_auth_6: undefined,
        ts_end_auth_notok_6: undefined
      },
      connection_id: false,
      formOk: false,
      formCadastroOk: false,
      isSaving: false,
      isAnswering: false,
      state: -1,
      username: "",
      mac: "",
      radiusServerIp: "",
      redirect_uri: "",
      redir_url: "",
      logo: undefined,
      primaryColor: undefined,
      secondaryColor: undefined,
      cadastrado: false,
      cpfRules: [
        v => (v && v.length > 10) || "CPF Incompleto",
        v => {
          var digits = [];
          var v1 = 0;
          var v2 = 0;
          if (v) {
            for (var i = 0; i < v.length; i++) {
              digits[i] = parseInt(v.charAt(i));
            }
          }

          v1 =
            (10 *
              (10 * digits[0] +
                9 * digits[1] +
                8 * digits[2] +
                7 * digits[3] +
                6 * digits[4] +
                5 * digits[5] +
                4 * digits[6] +
                3 * digits[7] +
                2 * digits[8])) %
            11;

          v2 =
            (10 *
              (11 * digits[0] +
                10 * digits[1] +
                9 * digits[2] +
                8 * digits[3] +
                7 * digits[4] +
                6 * digits[5] +
                5 * digits[6] +
                4 * digits[7] +
                3 * digits[8] +
                2 * digits[9])) %
            11;

          v1 = v1 % 10;
          v2 = v2 % 10;

          return (v1 == digits[9] && v2 == digits[10]) || "CPF inválido";
        },
        v => {
          return !/(.)\1{10,}/.test(v) || "Dígitos não permitidos";
        },
        v => {
          return v != "01234567890" || "Sequencia não permitida";
        }
      ],
      genders: [
        { id: "m", description: "Masculino" },
        { id: "f", description: "Feminino" },
        { id: "na", description: "NA" }
      ],
      client_data: {},
      terms_accepted: [],
      lgpd_accepted: {},
      skipMidia: 0,
      editedUser: {}
    };
  },
  
  methods: {
    changeLanguage() {
      i18n.locale = this.selectedLanguage;
      this.formatFieldsToLang(this.selectedLanguage);
    },
    autoChangeLanguage() {
      if (this.selectedLanguage == "pt-BR") {
        this.selectedLanguage = "en-US";
      } else {
        this.selectedLanguage = "pt-BR";
      }
      i18n.locale = this.selectedLanguage;
      this.formatFieldsToLang(this.selectedLanguage);
    },
    proximo() {
      this.state += 1;
      var self = this;

      if (this.state === 2) {
        const skipMidia = setTimeout(() => {
          if (this.state === 2) this.imageLoadError(2);
        }, 45000);
      } else if (this.state === 3) {
        //var now =  ((new Date(`${new Date()} GMT`)).toISOString()).replace('.000Z','-03:00')
        var now = new Date();
        this.userAuth["now"] = now;

        /* if (this.userAuth.hasOwnProperty("gender"))
          this.userAuth["gender"] = this.userAuth["gender"].toUpperCase(); */


        var responseApiExternal = new Promise(async resolve => {
          if (this.newUser) {
            resolve(
              db.authExternalApi(this.client_id, this.mac, this.userAuth)
            );
          } else {
            if (this.isEditing) {
              var cloneUser = JSON.parse(JSON.stringify(this.userAuth));

              Object.keys(this.isEditingObject).forEach(key => {
                if (this.isEditingObject[key].changed) {
                  Object.keys(cloneUser).forEach(key2 => {
                    if (key == key2) {
                    } else {
                      delete cloneUser[key2];
                    }
                  });
                }
              });
              this.editedUser = JSON.parse(JSON.stringify(cloneUser));
              this.editedUser["mac"] = this.userAuth.mac;

              resolve(
                db.authExternalApi(this.client_id, this.mac, this.editedUser)
              );
            } else {
              resolve(db.authExternalApi(this.client_id, this.mac, this.mac));
            }
          }
        });



        responseApiExternal.then(apiResponse => {
          if (apiResponse.data.success) {
            function cparet(thisObject) {
                if (thisObject.cpa == "swarm") {
                  thisObject.$refs.btn1.click();
                } else if (thisObject.cpa == "mikrotik") {
                  thisObject.$refs.btn2.click();
                } else {
                  thisObject.$refs.btn1.click(); // se nao tiver campo CPA, considerar Swarm
                }
             }
            
            this.connection.ts_start_auth_6 = getTimestamp();


            db.updateConnection(this.connection)
              .then(conn => {})
              .catch(err => {});

            if (this.newUser) {
              db.insertUserAuth(this.userAuth).then(response => {
                db.sendDataExtApi(
                  this.client_id,
                  this.mac,
                  this.connection.id
                ).then(result => {});
                this.connection.ts_end_auth_6 = getTimestamp();
                db.updateConnection(this.connection)
                  .then(conn => {
                    setTimeout(_ => {
                      if (this.isRadius) {
                        db.getRadcheck(this.userAuth.mac).then(resRadcheck => {
                          if (resRadcheck.data.data == "0") {
                            db.postRadcheck({
                              username: this.userAuth.mac,
                              value: "senharadius"
                            }).then(resRadcheck2 => {
                              cparet(this);
                            });
                          } else {
                            cparet(this);
                          }
                        });
                      } else {
                        cparet(this);
                      }
                    }, 200);
                  })
                  .catch(err => {});
              });
            } else {
              var cloneUser = JSON.parse(JSON.stringify(this.userAuth));

              Object.keys(this.isEditingObject).forEach(key => {
                if (this.isEditingObject[key].changed) {
                  Object.keys(cloneUser).forEach(key2 => {
                    if (key == key2) {
                    } else {
                      delete cloneUser[key2];
                    }
                  });
                }
              });
              this.editedUser = JSON.parse(JSON.stringify(cloneUser));
              this.editedUser["mac"] = this.userAuth.mac;
              db.updateUserAuth(this.editedUser).then(response => {
                db.sendDataExtApi(
                  this.client_id,
                  this.mac,
                  this.connection.id
                ).then(result => {});
                this.connection.ts_end_auth_6 = getTimestamp();
                db.updateConnection(this.connection)
                  .then(conn => {
                    setTimeout(_ => {
                       if (this.isRadius) {
                        db.getRadcheck(this.userAuth.mac).then(resRadcheck => {
                          if (resRadcheck.data.data == "0") {
                            db.postRadcheck({
                              username: this.userAuth.mac,
                              value: "senharadius"
                            }).then(resRadcheck2 => {
                              cparet(this);
                            });
                          } else {
                            cparet(this);
                          }
                        });
                      } else {
                        cparet(this);
                      }
                    }, 200);
                  })
                  .catch(err => {});
              });
            }
          } else {
            this.connection.ts_end_auth_notok_6 = getTimestamp();

            db.updateConnection(this.connection)
              .then(conn => {})
              .catch(err => {});
            alert(apiResponse.data.message || "Unauthorized");

            if (location.href.indexOf("?auths=") == -1)
              location.href = location.href.replace("?", "?auths=no&");
            else this.$router.go();

          }
        });
      }
    },
    acceptAllTerms() {
           this.terms_accepted = [];
      this.terms_accepted.push("termsOfUse");
      this.client_data.lgpd.forEach(term => {
        this.terms_accepted.push(term.id);
      });
      this.insertConsultor();
    },
     insertConsultor() {
      this.userAuth.mac = this.mac;

      if (!this.userAuth.terms_accepted) this.userAuth.terms_accepted = {};
      this.userAuth.terms_accepted[this.client_data.id] = this.terms_accepted;

      if (!this.userAuth.time_accepted) this.userAuth.time_accepted = {};
      this.userAuth.time_accepted[this.client_data.id] = new Date();

      this.userAuth.lang = this.selectedLanguage;

      if (this.newUser) {
        var done = false;
        var found = false;

        for (var i = 0; i < this.questions.length && !done; i++) {
          var question = this.questions[i];
          found = false;

          if (
            this.userAuth &&
            this.userAuth.answers &&
            this.userAuth.answers.some(e => e.question_id === question.id)
          ) {
            found = true;
          }

          if (!found) {
            this.randomQuestion = question;
            done = true;
          }
        }

        this.state = 1;
      } else {
        var done = false;
        var found = false;

        for (var i = 0; i < this.questions.length && !done; i++) {
          var question = this.questions[i];
          found = false;

          if (
            this.userAuth &&
            this.userAuth.answers &&
            this.userAuth.answers.some(e => e.question_id === question.id)
          ) {
            found = true;
          }

          if (!found) {
            this.randomQuestion = question;
            done = true;
          }
        }

        this.state = 1;
      }
    },
    playVideo(evt) {
      evt.target.play();
    },
    getQueryString(name) {
      var search = window.location.href.split("?")[1];

      var searchParts = search.split("&");
      var param = undefined;
      if (searchParts) {
        searchParts.forEach(el => {
          var keyValue = el.split("=");
          var key = keyValue[0];
          var value = keyValue[1];

          if (key === name) param = value;
        });
      }

      if (param) {
        return param;
      } else {
        return null;
      }
    },

    getQueryStringRE(name) {
      var search = window.location.href.split("?")[1];
      var saida = null;

      var params = decodeURIComponent(search)
        .replace(/(state\=)|(\{\")|(\"\})/g, "")
        .match(/(\w|\-)+(\=)(\w|\:|\/|\-|\.|\%)+/g);

      params.forEach(param => {
        var p = param.replace("%3D", "=");
        var key = p.split("=")[0];
        var value = decodeURIComponent(p.split("=")[1]);

        if (key === name) saida = value;
      });

      return saida;
    },
    choiceAnswer(answer) {
      this.isAnswering = true;
      if (!this.userAuth.answers) {
        this.userAuth.answers = [];
      }
      this.userAuth.answers.push({
        question_id: this.randomQuestion.id,
        id: answer.id,
        text: answer.text
      });

     (async () => {
        try {
          this.videos = db.getAvailableCampaign(this.client, this.mac);

          if (this.videos.data.length > 0) {
            var selectedVideos = [];

            /*if (this.userAuth.hasOwnProperty("answers")) {
                var user = JSON.parse(JSON.stringify(this.userAuth));

                this.videos.forEach(video => {
                  var matchVideo = true;

                  if (
                    video.hasOwnProperty("showQt") &&
                    video.showQt != undefined &&
                    video.showQt <= this.totalShows(video.viewData)
                  ) {
                    matchVideo = false;
                  } else {
                    user.answers.forEach(userAnswer => {
                      if (video.hasOwnProperty("targetQuestions")) {
                        var questions = video.targetQuestions.filter(
                          quest => quest.question_id == userAnswer.question_id
                        );

                        questions.forEach(question => {
                          if (question && question.hasOwnProperty("answers")) {
                            var answerSat = question.answers.find(
                              vidAnswer => vidAnswer.id == userAnswer.id
                            );
                            matchVideo = matchVideo && answerSat.chooseAnswer;
                          }
                        });
                      }
                    });

                    var okDay = true;

                    if (video.hasOwnProperty("days")) {
                      if (
                        !video.days.find(el => parseInt(el) == this.dayOfWeek)
                      )
                        okDay = false;
                    }

                    var okHour = false;

                    if (video.hasOwnProperty("hourRanges")) {
                      video.hourRanges.forEach(el => {
                        var hs = parseInt(el.split("-")[0]);
                        var he = parseInt(el.split("-")[1]);

                        if (this.hour < he && this.hour >= hs) okHour = true;
                      });
                    } else {
                      okHour = true;
                    }

                    matchVideo = matchVideo && okHour && okDay;
                  }

                  if (matchVideo) selectedVideos.push(video);
                });
              }  else*/
            selectedVideos = this.videos.data;

            this.randomVideo =
              selectedVideos[Math.floor(selectedVideos.length * Math.random())];
          } else {
            this.randomVideo = null;
          }

          this.proximo();
        } catch (error) {
          this.proximo();
        }
      })();
    },
    skipAnswer() {
      this.isAnswering = true;
      this.proximo();
    },
    loadedImage() {
      var tempoMidia = this.randomVideo.tempoMidia || 10;

      var interval = setInterval(() => {
        this.tempoPassado += 100 / (tempoMidia - 1);
      }, 1000);

      setTimeout(() => {
        clearInterval(interval);
        this.endVideo();
      }, tempoMidia * 1000);
    },
    imageLoadError(loadErr) {
      console.log("Image failed to load");
      var message = "";
      if (loadErr == 1)
        message = "Midia @" + this.randomVideo.mediaLink + " not found.";
      else if (loadErr == 2)
        message = "Midia @" + this.randomVideo.name + " loaded indefinitely.";
      else message = "something went wrong";

      db.logNotification(this.client, message, "imageLoadError");
      this.proximo();
    },
    parse(jsonStr, user_data) {
      var body = jsonStr;

      var values = body.match(/\$(\w+)/g);

      if (values) {
        values.forEach(value => {
          var key = value.replace("$", "");

          if (typeof user_data[key] == "string") {
            body = body.replace(value, '"' + user_data[key] + '"');
          } else {
            body = body.replace(value, user_data[key]);
          }
        });
      }

      body = body.replace("\n", "");

      body = JSON.parse(JSON.stringify(JSON.parse(body)));

      return body;
    },
    statusChangeCallback(result) {
      if (result.status == "connected") {
        FB.api("/me", "GET", { fields: "id,name,email" }, userInformation => {
          this.userAuth["email"] = userInformation.email;
          this.userAuth["name"] = userInformation.name;
        });
      } else if (result.status == "unknown") {
        this.userAuth["email"] = "";
        this.userAuth["name"] = "";
      }
    },
    checkLoginState() {
      /* FB.getLoginStatus(response => {
        this.statusChangeCallback(response);
      }); */
    },
    endVideo() {
      var dataObject = {
        event: "media_viewed",
        category: "captive",
        label: "auth"
      };
      if (typeof dataLayer != "undefined") {
        dataLayer.push(dataObject);
      }

      if (!this.randomVideo.hasOwnProperty("viewData")) {
        this.randomVideo["viewData"] = [
          {
            id: 0,
            label: "0 a 14",
            data: [0, 0, 0],
            value: [0, 14]
          },
          {
            id: 1,
            label: "15 a 20",
            data: [0, 0, 0],
            value: [15, 20]
          },
          {
            id: 2,
            label: "21 a 30",
            data: [0, 0, 0],
            value: [21, 30]
          },
          {
            id: 3,
            label: "31 a 40",
            data: [0, 0, 0],
            value: [31, 40]
          },
          {
            id: 4,
            label: "41 a 50",
            data: [0, 0, 0],
            value: [41, 50]
          },
          {
            id: 5,
            label: "51 a 60",
            data: [0, 0, 0],
            value: [51, 60]
          },
          {
            id: 6,
            label: "61 ou mais",
            data: [0, 0, 0],
            value: [61, 110]
          },
          {
            id: 7,
            label: "Não informado",
            data: [0, 0, 0]
          }
        ];
      }

      if (this.randomVideo.viewData.length == 7) {
        this.randomVideo.viewData.push({
          id: 7,
          label: "Não informado",
          data: [0, 0, 0]
        });
      }

      var dateParts = this.userAuth.birth_date.split("/");
      var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      var ageDifMs = Date.now() - dateObject;
      var ageDate = new Date(ageDifMs); // miliseconds from epoch
      var age = Math.abs(ageDate.getUTCFullYear() - 1970);

      if (isNaN(age)) {
        if (this.userAuth.gender == "m") this.randomVideo.viewData[7].data[0]++;
        else if (this.userAuth.gender == "f")
          this.randomVideo.viewData[7].data[1]++;
        else this.randomVideo.viewData[7].data[2]++;
      } else {
        for (var i = 0; i < 7; i++) {
          var el = this.randomVideo.viewData[i];

          if (el.data.length == 2) el.data.push(0);

          if (age >= el.value[0] && age < el.value[1]) {
            if (this.userAuth.gender == "m") el.data[0]++;
            else if (this.userAuth.gender == "f") el.data[1]++;
            else el.data[2]++;
          }
        }
      }

      db.updateManifest(this.randomVideo).then(response => {});

      this.proximo();
    },
    fbLogin() {
      var url =
        "https://www.facebook.com/v3.2/dialog/oauth?client_id=1661555860751899&redirect_uri=" +
        this.urlCaptive +
        '&state={"client=' +
        this.client +
        ",user_mac=" +
        decodeURIComponent(this.mac) +
        ",user_ip=" +
        decodeURIComponent(this.userIp) +
        ",redirect_uri=" +
        decodeURIComponent(this.redirect_uri) +
        '"}&scope=email';

      window.location.href = url;

      this.connection.ts_start_facebook_2 = getTimestamp();
    },
    fbGetToken(code) {
      var self = this;

      var url =
        "https://graph.facebook.com/v3.2/oauth/access_token?client_id=1661555860751899&redirect_uri=" +
        this.urlCaptive +
        "&client_secret=e13960939609b1aac57f77a1996e9251&code=" +
        code;

      axios.get(url).then(response => {
        self.fbGetUserData(response.data.access_token);
      });
    },
    fbGetUserData(token) {
      var self = this;

      var url =
        "https://graph.facebook.com/me?fields=email,name&access_token=" + token;

      axios.get(url).then(response => {
        self.userAuth.name = response.data.name;
        self.userAuth.email = response.data.email;

        this.connection.ts_end_facebook_2 = getTimestamp();
        db.updateConnection(this.connection)
          .then(conn => {})
          .catch(err => {});
      });
    },
   optin() {
      this.dialog = false;
      this.userAuth.termoAceito = true;
      this.terms_accepted.push("termsOfUse");
    },
    continueFlow() {
      var self = this;
      if (self.userDataComplete()) {
        this.state = 1;
      } else {
        this.editUserData();
        this.isEditing = false
        self.userDataFieldError.forEach(function(fieldname) {
          setTimeout(function() {
            self.$refs["ref-" + fieldname][0].focus();
          }, 500);
        });
      }
    },
    editUserData() {
      this.isEditing = true;
      this.cloneAndHideFields();
      this.state = 0;
    },
    replaceUser() {
      //this.isReplacingUser = true;
      //this.isEditing = false;

      this.isSure = true;
      this.deleteType = "not-i-am";
    },
    cloneAndHideFields() {
      this.userAuthClone = JSON.parse(JSON.stringify(this.userAuth));

      this.activeFields.forEach(field => {
        var fieldName = field.name;
        var fieldType = field.type;
        if (fieldType == "string") {
          var fieldLength = this.userAuth[fieldName]
            ? this.userAuth[fieldName].length
            : 0;
          this.isEditingObject[fieldName] = {
            editing: true,
            changed: false,
            test: true
          };

          try {
            if (this.userAuth[fieldName].indexOf("@") != -1) {
              var usrEmail = this.userAuth[fieldName].split("@")[0];
              var srvEmail = this.userAuth[fieldName].split("@")[1];
              this.userAuth[fieldName] =
                usrEmail.substring(0, Math.floor(usrEmail.length / 2)) +
                "*".repeat(
                  Math.ceil(usrEmail.length / 2) + srvEmail.length + 1
                );
            } else {
              this.userAuth[fieldName] =
                this.userAuth[fieldName].substring(
                  0,
                  Math.floor(fieldLength / 3)
                ) + "*".repeat(Math.ceil((2 * fieldLength) / 3));
            }
          } catch (error) {}
        } else if (fieldType == "list" || fieldType == "date") {
          this.isEditingObject[fieldName] = {
            editing: true,
            changed: false,
            test: true
          };
        } else {
          this.isEditingObject[fieldName] = {
            editing: false,
            changed: false,
            test: true
          };
        }
      });
    },
    editField(field, clearField) {
      if (this.isEditing) {
        if (clearField) this.userAuth[field.name] = "";

        this.isEditingObject[field.name] = {
          editing: false,
          changed: true,
          test: true
        };
      }
    },
    goBoasVindas() {
      this.state = -1;
      this.userAuth = JSON.parse(JSON.stringify(this.userAuthClone));
      this.state = 10;
      this.isEditing = false;
      this.isEditingObject = {};
    },
    optout() {
      this.isSure = true;
      this.deleteType = "optout";
    },
    updateUserAuth() {
      this.state = 3;

      Object.keys(this.isEditingObject).forEach(key => {
        if (this.isEditingObject[key].changed) {
          this.userAuthClone[key] = this.userAuth[key];
        }
      });

      this.userAuth = JSON.parse(JSON.stringify(this.userAuthClone));

      this.insertConsultor();
    },
    formUpdateOk() {
      var saida = true;

      Object.keys(this.isEditingObject).forEach(key => {
        var field = this.activeFields.find(el => el.name == key);

        if (field) {
          if (this.isEditingObject[key].changed) {
            if (
              !field.required &&
              typeof this.userAuth[key] == "string" &&
              this.userAuth[key].length == 0
            ) {
            } else {
              if (key == "cpf") {
                this.cpfRules.forEach(rule => {
                  var test = rule(this.userAuth[key]) === true ? true : false;
                  saida = saida && test;
                });
              } else if (key == "phone") {
                this.rulePhone.forEach(rule => {
                  var test = rule(this.userAuth[key]) === true ? true : false;
                  saida = saida && test;
                });
              } else if (key == "name") {
                this.ruleName.forEach(rule => {
                  var test = rule(this.userAuth[key]) === true ? true : false;
                  saida = saida && test;
                });
              } else if (key == "email") {
                this.ruleEmail.forEach(rule => {
                  var test = rule(this.userAuth[key]) === true ? true : false;
                  saida = saida && test;
                });
              } else if (key == "birth_date") {
                this.ruleData.forEach(rule => {
                  var test = rule(this.userAuth[key]) === true ? true : false;
                  saida = saida && test;
                });
              } else {
                var test = this.userAuth[key].length > 0;
                saida = saida && test;
              }
            }
          }
        }

        //saida = saida && this.isEditingObject[key].test;
      });

      return saida;
    },
    isDirty() {
      Object.keys(this.isEditingObject).forEach(key => {
        if (this.isEditingObject[key].changed) return true;
      });

      // const lgpd_accepted_keys = Object.keys(this.lgpd_accepted);
      // if (
      //   lgpd_accepted_keys.some(
      //     el => !this.userAuth.terms_accepted.includes(el)
      //   )
      // )
      //   return true;
      // if (
      //   this.userAuth.terms_accepted.some(
      //     el => !lgpd_accepted_keys.includes(el)
      //   )
      // )
      //   return true;
      if (this.userAuthClone["termoAceito"] != this.userAuth["termoAceito"])
        return true;

      return false;
    },
    commitOut() {
      var self = this;

      if (
        self.deleteType == "optout" &&
        self.userAuth.hasOwnProperty("cpf") &&
        self.userAuth.cpf
      ) {
        db.deleteUserAuthByCpf(self.userAuth.cpf).then(function(response) {
          self._fbCode = undefined;
          self._fbToken = undefined;
          self.newUser = true;
          self.state = 11;

          self.userAuth = { termoAceito: false, answers: [] };
          self.termoAceito = false;

          self.isSure = false;

          try {
            self.$router.go();
          } catch (exc) {
            self.message.title = "Resultado";
            self.message.text = "Erro: Não foi possível recarregar o portal";
            self.message.action = () => {
              self.dialogMessage = false;
            };

            self.dialogMessage = true;
          }
        });
      } else {
        db.deleteUserAuth(self.userAuth.mac).then(function(response) {
          self._fbCode = undefined;
          self._fbToken = undefined;
          self.newUser = true;
          self.state = 11;

          self.userAuth = { termoAceito: false, answers: [] };
          self.termoAceito = false;

          self.isSure = false;

          try {
            self.$router.go();
          } catch (exc) {
            self.message.title = "Resultado";
            self.message.text = "Erro: Não foi possível recarregar o portal";
            self.message.action = () => {
              self.dialogMessage = false;
            };

            self.dialogMessage = true;
          }
        });
      }
    },
    changeDate(field) {
      if (this.isEditing) {
        this.isEditingObject[field] = {
          editing: false,
          changed: true,
          test: true
        };
      }

      this.userAuth[field] =
        this.userAuth[field + "_dd"] +
        "/" +
        this.userAuth[field + "_mm"] +
        "/" +
        this.userAuth[field + "_yyyy"];

      this.userAuthClone[field + "_dd"] = this.userAuth[field + "_dd"];
      this.userAuthClone[field + "_mm"] = this.userAuth[field + "_mm"];
      this.userAuthClone[field + "_yyyy"] = this.userAuth[field + "_yyyy"];
    },
    userDataComplete() {
      var saida = true;

      var self = this;

      self.userDataFieldError = [];

      for (var i = 0; i < self.activeFields.length; i++) {
        var key = self.activeFields[i].name;
        var type = self.activeFields[i].type;
        var test = true;
        var required = self.activeFields[i].required;

        if (required) {
          if (self.userAuth[key]) {
            if (key == "cpf") {
              self.cpfRules.forEach(rule => {
                test = rule(self.userAuth[key]) === true ? true : false;
              });
            } else if (key == "phone") {
              self.rulePhone.forEach(rule => {
                test = rule(self.userAuth[key]) === true ? true : false;
              });
            } else if (key == "name") {
              self.ruleName.forEach(rule => {
                test = rule(self.userAuth[key]) === true ? true : false;
              });
            } else if (key == "email") {
              self.ruleEmail.forEach(rule => {
                test = rule(self.userAuth[key]) === true ? true : false;
              });
            } else if (key == "birth_date") {
              self.ruleData.forEach(rule => {
                test = rule(self.userAuth[key]) === true ? true : false;
              });
            } else {
              if (type.toLowerCase() == "number") {
                test =
                  self.userAuth[key] !== null &&
                  self.userAuth[key] !== undefined;
              } else if (
                type.toLowerCase() == "string" ||
                type.toLowerCase() == "password"
              ) {
                test = self.userAuth[key].length > 0;
              } else if (type.toLowerCase() == "date") {
                test = !isNaN(
                  new Date(
                    self.userAuth[key + "_yyyy"] +
                      "/" +
                      self.userAuth[key + "_mm"] +
                      "/" +
                      self.userAuth[key + "_dd"]
                  ).getTime()
                );
              } else if (type.toLowerCase() == "list") {
                test = !!self.userAuth[key];
              } else {
                test = true;
              }
            }
          } else {
            test = false;
          }
        }

        saida = saida && test;

        if (!test) self.userDataFieldError.push(key);
      }

      if (!self.userAuth["termoAceito"]) {
        // var term = "termsOfUse";
        // self.userAuth.terms_accepted.push(
        //   term + this.client_data.controller_id
        // );

        // this.client_data.lgpd.forEach(term => {
        //   self.userAuth.terms_accepted.push(term.id);
        // });
        saida = false;
      }

      // if(this.userAuth.time_accepted[this.client_data.id] < this.client_data.lgpd_time){
      // //   saida = false;
      // // }

      return saida;
    },

    formatFieldsToLang(lang) {
      if (lang == "pt-BR") {
        this.fields.forEach(field => {
          if (field.hasOwnProperty("i18n")) {
            field.label = field.i18n[0].label;
            field.is_active = field.i18n[0].is_active;
            field.required = field.i18n[0].required;
            if (field.hasOwnProperty("options")) {
              field.options = field.i18n[0].options;
            }
          }
        });
      } else if (lang == "en-US") {
        this.fields.forEach(field => {
          if (field.hasOwnProperty("i18n")) {
            field.label = field.i18n[1].label;
            field.is_active = field.i18n[1].is_active;
            field.required = field.i18n[1].required;
            if (field.hasOwnProperty("options")) {
              field.options = field.i18n[1].options;
            }
          }
        });
      }

      this.$forceUpdate();
    },
    applyRules(rules, value) {
      var saida = true;

      try {
        rules.forEach(function(rule) {
          var test = rule(value) === true ? true : false;
          saida = saida && test;
        });
      } catch (exc) {
        saida = false;
      }

      return saida;
    },
    buscaCpf() {
      if (
        this.isCpfRequired &&
        this.applyRules(this.cpfRules, this.userAuth.cpf)
      ) {
        this.connection.ts_start_cpf_2 = getTimestamp();

        db.getUserAuthByCpf(this.userAuth.cpf)
          .then(res => {
            this.conformUserAuth();

            db.getUserAuthByMac(res.data.mac)
              .then(response => {
                this.userAuth = response.data;

                if (this.detectUser) this.conformUserAuth();
                else this.clearFormUserAuth();

                if (this.userAuth.hasOwnProperty("lang")) {
                  if (!this.hasLangEnUs) {
                    this.selectedLanguage = "pt-BR";
                    this.changeLanguage();
                  } else {
                    this.selectedLanguage = this.userAuth.lang;
                    this.changeLanguage();
                  }
                }

                if (
                  this.userAuth.hasOwnProperty("terms_accepted") &&
                  this.userAuth.terms_accepted[this.client_data.id]
                ) {
                  this.terms_accepted = this.userAuth.terms_accepted[
                    this.client_data.id
                  ];
                }

                if (this._fbCode) this.fbGetToken(this._fbCode);

                var nextSt = 10;

                if (!this.detectUser || this.auth_success == "no") nextSt = 0;
                this.newUser = false;

                this.state = nextSt;

                db.getQuestionsByControllerId(this.client)
                  .then(response2 => {
                    this.questions = response2.data;
                    var done = false;
                    var found = false;

                    for (var i = 0; i < this.questions.length && !done; i++) {
                      var question = this.questions[i];
                      found = false;

                      if (
                        this.userAuth &&
                        this.userAuth.answers &&
                        this.userAuth.answers.some(
                          e => e.question_id === question.id
                        )
                      ) {
                        found = true;
                      }

                      if (!found) {
                        this.randomQuestion = question;
                        done = true;
                      }
                    }

                    this.questionPending = false;
                  })
                  .catch(error2 => {
                    this.questionPending = false;
                  });

                this.connection.ts_end_load_1 = getTimestamp();

                db.updateConnection(this.connection)
                  .then(conn => {})
                  .catch(err => {});
              })
              .catch(error => {
                var nextSt = 11;

                if (this.detectUser) {
                  this.conformUserAuth();
                  nextSt = 11;
                } else {
                  this.clearFormUserAuth();
                  nextSt = 0;
                }

                if (this._fbCode) this.fbGetToken(this._fbCode);
                if (this._fbCode) this.state = 0;
                else this.state = nextSt;

                db.getQuestionsByControllerId(this.client).then(response => {
                  this.questions = response.data;
                  this.randomQuestion = this.questions[0];
                });

                this.connection.ts_end_load_1 = getTimestamp();

                db.updateConnection(this.connection)
                  .then(conn => {})
                  .catch(err => {});
              });
          })
          .catch(error2 => {
            this.conformUserAuth();

            this.connection.ts_end_cpf_2 = getTimestamp();
            db.updateConnection(this.connection)
              .then(conn => {})
              .catch(err => {});
          });
      }

      this.state = 0;
    },
    conformUserAuth() {
      this.activeFields.forEach(field => {
        if (!this.userAuth.hasOwnProperty(field.name)) {
          if (
            field.type == "list" ||
            field.type == "string" ||
            field.type == "password"
          )
            this.userAuth[field.name] = "";
          else if (field.type == "date") {
            this.userAuth[field.name] = "";
            this.userAuth[field.name + "_dd"] = "";
            this.userAuth[field.name + "_mm"] = "";
            this.userAuth[field.name + "_yyyy"] = "";
          } else if (field.type == "number") this.userAuth[field.name] = 0;
          else if (field.type == "boolean") this.userAuth[field.name] = false;
        }
      });

      this.$forceUpdate();
    },
    clearFormUserAuth() {
      this.activeFields.forEach(field => {
        if (
          field.type == "list" ||
          field.type == "string" ||
          field.type == "password"
        )
          this.userAuth[field.name] = "";
        else if (field.type == "date") {
          this.userAuth[field.name] = "";
          this.userAuth[field.name + "_dd"] = "";
          this.userAuth[field.name + "_mm"] = "";
          this.userAuth[field.name + "_yyyy"] = "";
        } else if (field.type == "number") this.userAuth[field.name] = 0;
        else if (field.type == "boolean") this.userAuth[field.name] = false;
      });

      this.$forceUpdate();
    },
    totalShows(viewData) {
      var saida = 0;
      viewData.forEach(vd => {
        saida += vd.data.reduce((acc, curr) => acc + curr);
      });

      return saida;
    }
  },
  watch: {
    lgpd_accepted: (new_value, old_value) => {
      console.log(new_value);
    },
    state(newValue) {
      if (newValue == 1) {
        this.connection.ts_end_ident_2 = getTimestamp();
        db.updateConnection(this.connection)
          .then(conn => {})
          .catch(err => {});
        this.connection.ts_start_question_3 = getTimestamp();

           (async () => {
          try {
            this.videos = await db.getAvailableCampaign(this.client, this.mac);

            if (this.videos.data.length > 0) {
              var selectedVideos = [];

              selectedVideos = this.videos.data;

              this.randomVideo =
                selectedVideos[
                  Math.floor(selectedVideos.length * Math.random())
                ];
            } else {
              this.randomVideo = null;
            }

            this.proximo();
          } catch (error) {
            this.proximo();
          }
        })();
      } else if (newValue == 2) {
        this.connection.ts_end_question_3 = getTimestamp();
        db.updateConnection(this.connection)
          .then(conn => {})
          .catch(err => {});
        this.connection.ts_start_midia_4 = getTimestamp();

        if (!this.randomVideo) {
          this.proximo();
        }
      } else if (newValue == 3) {
        this.connection.ts_end_midia_4 = getTimestamp();
        db.updateConnection(this.connection)
          .then(conn => {})
          .catch(err => {});
      }
    }
  },
  computed: {
    // userAcceptedTerms() {
    //   var client = this.client_data.controller_id;
    //   let index = this.userAuth.terms_accepted.findIndex(
    //     term => term === "termsOfUse" + client
    //   );

    //   return index !== -1;
    // },
    filledRequiredFields() {
      let filled = true;
      this.fields.forEach(field => {
        if (field.is_active) {
          if (field.name && field.required && this.userAuth[field.name] == "")
            filled = false;
        }
      });

      return filled;
    },
    getLanguages() {
      return this.languages.filter(lang => lang.language == i18n.locale);
    },
    hasLangEnUs() {
      var saida = false;

      saida = this.fields.some(field => field.i18n[1].is_active);

      return saida;
    },
    userAuthField() {
      if (this.userAuth[this.auth_user_field]) {
        return this.userAuth[this.auth_user_field];
      } else {
        return this.userAuth.email;
      }
    },
    formSubmit() {
      var saida = this.redirect_uri;

      if (!this.isAPAuto) {
        var isIP = false;
        try {
          isIP = /\:\/\/\d+/.test(this.redirect_uri);
        } catch (exc) {
          isIP = false;
        }

        if(this.cpa == "mikrotik"){
          var saida = this.redirect_uri;
        }else{
          var saida = this.redirect_uri + "/?redirurl=" + this.redir_url;
        }

        if (isIP){
          saida =
            saida.replace("https", "http") 
        } else{
          saida =
            saida.replace("http", "https")
        }
          
      } else {
        var saida = this.redirect_uri;
      }

      return saida;
    },
    midiaLink() {
      return this.randomVideo.mediaLink;
    },
    midiaType() {
      return this.randomVideo.type.split("/")[0];
    },
    activeFields() {
      return this.fields.filter(el => el.is_active);
    },
    dias() {
      var dias = [];

      for (var i = 0; i < 31; i++) {
        var dia = { text: "" + (i + 1), value: "" + (i + 1) };
        if (i < 9) dia = { text: "0" + (i + 1), value: "0" + (i + 1) };

        dias.push(dia);
      }

      return dias;
    },
    meses() {
      var meses = [
        {
          value: "01",
          text: "Jan"
        },
        {
          value: "02",
          text: "Fev"
        },
        {
          value: "03",
          text: "Mar"
        },
        {
          value: "04",
          text: "Abr"
        },
        {
          value: "05",
          text: "Mai"
        },
        {
          value: "06",
          text: "Jun"
        },
        {
          value: "07",
          text: "Jul"
        },
        {
          value: "08",
          text: "Ago"
        },
        {
          value: "09",
          text: "Set"
        },
        {
          value: "10",
          text: "Out"
        },
        {
          value: "11",
          text: "Nov"
        },
        {
          value: "12",
          text: "Dez"
        }
      ];

      return meses;
    },
    anos() {
      var anos = [];

      for (var i = 5; i <= 100; i++)
        anos.push({ text: "" + (2020 - i), value: "" + (2020 - i) });
      return anos;
    },
    isCpfRequired() {
      var saida = false;
      var cpfField = this.fields.find(el => el.name == "cpf");

      if (cpfField) saida = cpfField.required;

      return saida;
    },
    welcome() {
      var saida = novo_parse(this.welcomeHeader_pt_BR, this.userAuth, false);

      if (this.selectedLanguage == "en-US") {
        saida = novo_parse(this.welcomeHeader_en_US, this.userAuth, false);
      } else {
      }

      if (!saida) {
        if (this.selectedLanguage == "pt-BR") saida = "Bem-vindo novamente!";
        else saida = "Welcome again!";
      }

      return saida;
    }
  },
  async mounted() {
 
    this.client = this.getQueryStringRE("client");
    //this.client_data = await db.getClientData(this.client);

    var self = this;
    //window.checkLoginState = this.checkLoginState;
    //window.statusChangeCallback = this.statusChangeCallback;
    var atual_date = new Date();
    this.hour = atual_date.getHours();

    this.dayOfWeek = atual_date.getDay();
    this.urlCaptive =
      location.protocol + "//" + location.host + location.pathname;

    var redirect_uri = this.getQueryStringRE("redirect_uri");
    var mac = this.getQueryStringRE("user_mac");
    var radiusServerIp = this.getQueryStringRE("radiusServerIp");
    var userIp = this.getQueryStringRE("user_ip");
    this._fbCode = this.getQueryStringRE("code");

    this.auth_success = this.getQueryStringRE("auths");
    this.cpa = this.getQueryStringRE("cpa");
    var radius = this.getQueryStringRE("radius");
    this.radius =  this.getQueryStringRE("radius");
    var uamIp = this.getQueryStringRE("uamip");
    var uamPort = this.getQueryStringRE("uamport");
    var newMac = this.getQueryStringRE("mac");
    var newIp = this.getQueryStringRE("ip");
    var userUrl = this.getQueryStringRE("userurl");

    this.redirect_uri = decodeURIComponent(redirect_uri).split("?")[0];
    this.mac = decodeURIComponent(mac);
    this.connection_id = this.getQueryStringRE("connection_id");
    this.radiusServerIp = decodeURIComponent(radiusServerIp);
    this.userIp = decodeURIComponent(userIp);
    ///// dev15
    this.connection.user_id = this.mac;
    this.connection.mac_address = this.mac;
    if (mde.userAgent()) {
      this.connection.user_agent = mde.userAgent();
      this.connection.os = mde.os();
    }
    this.connection.ip = this.userIp;
    this.connection.controller_id = this.client;

    this.connection.ts_start_load_1 = getTimestamp();
    if (!this.connection_id) {
      db.saveConnection(this.connection).then(conn => {
        this.connection["id"] = conn.data.id;
      });
    } else {
      this.connection["id"] = parseInt(this.connection_id);
      db.updateConnection(this.connection)
        .then(conn => {})
        .catch(err => {});
    }
    ///// dev15

    if (!!uamIp && uamIp.length > 0) {
      this.isAPAuto = true;
      if (!!newMac) newMac = newMac.toUpperCase().replace(/\-/g, ":");

      this.redirect_uri = "http://" + uamIp + ":" + uamPort + "/json/logon";
      mac = newMac;
      this.mac = newMac;
      this.userIp = newIp;
      this.uamIp = uamIp;
      this.uamPort = parseInt(uamPort);
      this.userurl = decodeURIComponent(userUrl);
    }
    if (!!radius) {
      this.isRadius = true;
    }
    db.getClientInfo(this.client).then(data => {
      this.client_data = data.data;
      console.log(this.client_data);
      this.client_id = data.data.id;
      this.logo = data.data.logo_base64;
      this.redir_url = data.data.url;
      this.primaryColor = data.data.primaryColor;
      this.secondaryColor = data.data.secondaryColor;
      this.fields = data.data.fields;
      this.api_settings = data.data.authApi || [];

      this.auth_user_field = data.data.auth_user_field || "name";

      this.export_settings = data.data.externalApi || [];
      if (this.export_settings.length > 0) {
        this.export_settings = this.export_settings.filter(el =>
          !el.hasOwnProperty("is_active") || el.is_active ? true : false
        );
      }
      this.termsOfUse = data.data.termsOfUse;

      this.termsOfUseEnglish = data.data.termsOfUseEnglish;
      this.zone = data.data.zone || "captive";
      this.withFacebook = data.data.hasOwnProperty("withFacebook")
        ? data.data.withFacebook
        : true;

      this.welcomeHeader_pt_BR = data.data.welcomeHeader_pt_BR || "";
      this.welcomeHeader_en_US = data.data.welcomeHeader_en_US || "";
      this.welcomeFooter_pt_BR = data.data.welcomeFooter_pt_BR || "";
      this.welcomeFooter_en_US = data.data.welcomeFooter_en_US || "";

      this.detectUser = true;

      if (data.data.hasOwnProperty("detectUser"))
        this.detectUser = data.data.detectUser;

      this.textColor = data.data.textColor || "black";

      this.formatFieldsToLang(this.selectedLanguage);

      for (var index in this.fields) {
        var field = this.fields[index];
        if (field.type == "date") {
          this.userAuth[field.name + "_dd"] = "";
          this.userAuth[field.name + "_mm"] = "";
          this.userAuth[field.name + "_yyyy"] = "";
        }
      }

      if (typeof document.body.style.cssText == "string") {
        document.body.style.cssText +=
          "background-color:" + data.data.backgroundColor;
        if (data.data.bg_base64) {
          document.body.style.cssText +=
            "; background-image: url('" +
            data.data.bg_base64 +
            "'); background-size: cover";
        }
      }
      this.isLoaded = true;

      db.getAnonUserAuthByMac(mac, this.client)
        .then(response => {
          this.userAuth = response.data;
          console.log(this.userAuth);
          if (this.detectUser) this.conformUserAuth();
          else this.clearFormUserAuth();

          if (this.userAuth.hasOwnProperty("lang")) {
            if (!this.hasLangEnUs) {
              this.selectedLanguage = "pt-BR";
              this.changeLanguage();
            } else {
              this.selectedLanguage = this.userAuth.lang;
              this.changeLanguage();
            }
          }

          if (
            this.userAuth.hasOwnProperty("terms_accepted") &&
            this.userAuth.terms_accepted[this.client_data.id]
          ) {
            this.terms_accepted = this.userAuth.terms_accepted[
              this.client_data.id
            ];
          }

          if (this._fbCode) this.fbGetToken(this._fbCode);

          var nextSt = 10;

          if (!this.detectUser || this.auth_success == "no") nextSt = 0;
          this.newUser = false;

          this.state = nextSt;

          // if (this.client_data.lgpd.length > 0) {
          //   this.client_data.lgpd.forEach(({ id }) => {
          //     this.lgpd_accepted[id] = this.userAuth.terms_accepted.includes(
          //       id
          //     );
          //   });

          //   console.log(this.lgpd_accepted);
          // }
          db.getQuestionsByControllerId(this.client)
            .then(response2 => {
              this.questions = response2.data;
              var done = false;
              var found = false;

              for (var i = 0; i < this.questions.length && !done; i++) {
                var question = this.questions[i];
                found = false;

                if (
                  this.userAuth &&
                  this.userAuth.answers &&
                  this.userAuth.answers.some(e => e.question_id === question.id)
                ) {
                  found = true;
                }

                if (!found) {
                  this.randomQuestion = question;
                  done = true;
                }
              }

              this.questionPending = false;
            })

            .catch(error2 => {
              this.questionPending = false;
            });

          this.connection.ts_end_load_1 = getTimestamp();

          db.updateConnection(this.connection)
            .then(conn => {})
            .catch(err => {});
        })
        .catch(error => {
          var nextSt = 11;

          if (this.detectUser) {
            this.conformUserAuth();
            nextSt = 11;
          } else {
            this.clearFormUserAuth();
            nextSt = 0;
          }

          if (this._fbCode) this.fbGetToken(this._fbCode);
          if (this._fbCode) this.state = 0;
          else this.state = nextSt;

          db.getQuestionsByControllerId(this.client).then(response => {
            this.questions = response.data;
            this.randomQuestion = this.questions[0];
          });

          this.connection.ts_end_load_1 = getTimestamp();

          db.updateConnection(this.connection)
            .then(conn => {})
            .catch(err => {});
        });

      /*
      db.getVideosDates(this.client).then(response => {
        this.videos = response.data;
        var selectedVideos = [];

        this.videos.forEach(video => {
          if (
            video.hasOwnProperty("showQt") &&
            video.showQt != undefined &&
            video.showQt <= this.totalShows(video.viewData)
          ) {
          } else {
            selectedVideos.push(video);
          }
        });

        if (selectedVideos.length > 0) {
          this.randomVideo =
            selectedVideos[Math.floor(selectedVideos.length * Math.random())];
        } else{}

        this.videoPending = false;
      });
      */
    });
  }
};

function novo_parse(jsonStr, data, isJson) {
  var saida = jsonStr;

  var body = jsonStr;
  var s = [];

  var values = body.match(/\$(\w+)/g);

  if (values)
    values.forEach(el => {
      if (s.indexOf(el) < 0) s.push(el);
    });

  var fstr = "return " + body.replace(/\"/g, "'").replace(/\'/g, '"');

  if (!isJson && s.length == 0) {
    fstr = "return '" + body.replace(/\"/g, "'").replace(/\'/g, '"') + "'";
  }

  var f = new Function(s.join(","), fstr);

  var p = [];

  s.forEach(el => {
    var key = el.replace("$", "");

    p.push(data[key]);
  });

  saida = f.apply(this, p);

  return saida;
}

function getTimestamp() {
  return new Date().getTime();
}
</script>

<style>
* {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  border-width: 1px !important;
}

.v-form > .container > .layout > .flex {
  padding-bottom: 0 !important;
}

.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: rgba(255, 255, 255, 0.92) !important;
}

select {
  background-color: rgba(216, 216, 216, 0.8);
  color: rgb(30, 30, 30);
  outline: none;
  padding: 4px 4px;
  border-radius: 2px;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.full {
  margin: 0 auto !important;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  min-height: 100%;
  width: auto;
  height: 100%;
  background-size: cover;
  background-color: black;
}

.fullImg {
  z-index: 999;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  object-fit: contain;
  overflow: hidden;
}

/* @media (orientation: portrait) {
  .fullImg {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: fixed;
    margin: auto;
    width: 100%;
    min-width: 100%;
    overflow: hidden;
  }
}

@media (orientation: landscape) {
  .fullImg {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    position: fixed;
    margin: auto;
    height: 100%;
    min-height: 100%;
    overflow: hidden;
  }
} */

.overlay {
  display: flex;
  z-index: 9999;
}

.cupom {
  position: absolute;
  z-index: 9999;
  left: 0;
  right: 0;
  margin-top: 0;
  margin-bottom: 0;
  margin-left: auto;
  margin-right: auto;
  top: 80vh;
  background-color: white;
  padding: 4px;
  overflow: hidden;
}

.center,
.center > * {
  margin-left: auto !important;
  margin-right: auto !important;
}

[v-cloak] {
  display: none;
}

.v-input__slot {
  margin-bottom: 0px !important;
}

.titulo {
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
}

.answer {
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  font-size: medium;
}

.date {
  width: 33% !important;
}

.button {
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
}

.meulink {
  text-decoration: underline blue;
  cursor: pointer;
}

.error--text * {
  color: #ff5252 !important;
}

/* Facebook */
.loginBtn--facebook {
  background-color: #4c69ba;
  background-image: linear-gradient(#4c69ba, #3b55a0);
  font-family: "Helvetica neue", Helvetica Neue, Helvetica, Arial, sans-serif;
  text-shadow: 0 -1px 0 #354c8c;
  text-transform: inherit !important;
  height: 44px !important;
  color: white !important;
  margin: 0 !important;
  padding-left: 0 !important;
}

.fullHeight {
  /* height: calc(100vh - 160px); */
  height: 100vh !important;
  padding-bottom: 88px !important;
}
figure.logo {
  position: fixed;
  top: 84vh;
  right: -33px;
  background-color: rgba(255, 255, 255, 0.4);
  padding: 4px 8px 0 8px;
  border-left: thin solid lightgrey;
  border-right: thin solid lightgrey;
  border-top: thin solid lightgrey;
  border-radius: 4px 4px 0 0;
  transform: rotate(-90deg) scale(0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/Captive.vue